import axios, { AxiosResponse } from 'axios';
import {
  AffiliatePayoutSettings,
  TAffiliateAccountProductLink,
  TAffiliateCheckoutPayload,
  TAffiliateCheckoutResponse,
} from '@src/types/affiliate';

export const joinAffiliateProgram = (): Promise<AxiosResponse<void>> => {
  return axios.post('/affiliate/');
};

export const createAffiliatePayoutSettings = (
  payload: AffiliatePayoutSettings
): Promise<AxiosResponse<AffiliatePayoutSettings>> => {
  return axios.post('/affiliate/payment-methods/', payload);
};

export const getAffiliateAccountLinks = (): Promise<
  AxiosResponse<TAffiliateAccountProductLink[]>
> => {
  return axios.get('/products/affiliate-eligible/');
};

export const affiliateCheckout = (
  payload: TAffiliateCheckoutPayload
): Promise<AxiosResponse<TAffiliateCheckoutResponse>> => {
  return axios.post('/affiliate/checkout/', payload);
};

export const getAffiliateProductByCode = (
  productCode: string
): Promise<AxiosResponse<TAffiliateAccountProductLink>> => {
  return axios.get(`/products/public/affiliate/${productCode}/`);
};
